import { isEvaluable, preevaluate } from "@next-core/cook";
import { isObject } from "@next-core/utils/general";
export function traverseStoryboardExpressions(data, beforeVisitGlobal,
// If `options` is a string, it means the *keyword*.
options) {
  const memo = new WeakSet();
  const {
    matchExpressionString,
    visitNotMatchedExpressionString,
    visitNonExpressionString,
    visitObject
  } = typeof options === "string" ? {
    matchExpressionString: v => v.includes(options)
  } : options;
  function traverse(value) {
    if (typeof value === "string") {
      if (isEvaluable(value)) {
        if (matchExpressionString(value)) {
          try {
            preevaluate(value, {
              cache: true,
              withParent: true,
              hooks: {
                beforeVisitGlobal(node, parent) {
                  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  beforeVisitGlobal(node, parent, value);
                }
              }
            });
          } catch (error) {
            // eslint-disable-next-line no-console
            console.error("Parse storyboard expression failed:", error);
          }
        } else {
          visitNotMatchedExpressionString === null || visitNotMatchedExpressionString === void 0 || visitNotMatchedExpressionString(value);
        }
      } else {
        visitNonExpressionString === null || visitNonExpressionString === void 0 || visitNonExpressionString(value);
      }
    } else if (isObject(value)) {
      // Avoid call stack overflow.
      if (memo.has(value)) {
        return;
      }
      memo.add(value);
      visitObject === null || visitObject === void 0 || visitObject(value);
      for (const item of Array.isArray(value) ? value : Object.values(value)) {
        traverse(item);
      }
    }
  }
  traverse(data);
}
//# sourceMappingURL=traverse.js.map